import React from 'react';
import Reveal from '../../../components/shared/Reveal';
import { EditableText, EditableImage } from '../../components';

function ImageTextTwoCol({ data, onChange }) {
  const update = (patch) => onChange && onChange({ ...data, ...patch });
  const left = data.image_position === 'left';
  const paragraphs = data.paragraphs || [];
  const updatePara = (i, t) => {
    const next = [...paragraphs];
    next[i] = t;
    update({ paragraphs: next });
  };
  const Img = (
    <Reveal key="img">
      <EditableImage
        src={data.image?.src}
        alt={data.image?.alt || ''}
        onChange={(src, alt) => update({ image: { src, alt } })}
        className="rounded-3xl shadow-soft h-[480px] w-full object-cover"
      />
    </Reveal>
  );
  const Txt = (
    <Reveal key="txt" delay={0.1}>
      <h2 className="section-title">
        <EditableText value={data.heading} onChange={(t) => update({ heading: t })} as="span" />
      </h2>
      {paragraphs.map((p, i) => (
        <EditableText
          key={i}
          value={p}
          onChange={(t) => updatePara(i, t)}
          as="p"
          multiline
          className={`${i === 0 ? 'mt-5' : 'mt-4'} text-ink/70 leading-relaxed`}
        />
      ))}
    </Reveal>
  );
  return (
    <section className="py-24 bg-white">
      <div className="container-page grid lg:grid-cols-2 gap-16 items-center">
        {left ? [Img, Txt] : [Txt, Img]}
      </div>
    </section>
  );
}

export default ImageTextTwoCol;
